// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"431":"360b332e","672":"4d44cc72","682":"8e6cfc72","711":"0d5e59ae","737":"e5f5ff96","770":"0e3305ef","772":"ba73325f"}[chunkId] + ".js";
};